// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-hero {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  padding: 160px 0 96px;
  color: var(--white);
  margin-bottom: 0;
}

.page-hero-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  animation: fadeInUp 0.8s ease-out;
}

.page-subtitle {
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 24px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 24px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.page-title {
  font-size: 56px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 28px;
  color: var(--white);
  letter-spacing: -0.5px;
}

.page-description {
  font-size: 18px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto;
}

.about-content {
  background: var(--white);
}

.content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.content-title {
  font-size: 36px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 32px;
}

.content-paragraph {
  font-size: 16px;
  line-height: 1.9;
  color: var(--text-light);
  margin-bottom: 24px;
}

.content-image {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.content-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  aspect-ratio: 4/5;
}

.mission-structure {
  background: var(--white);
}

.structure-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 60px;
}

.structure-card {
  text-align: center;
  padding: 40px 30px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  border-radius: 16px;
  color: var(--white);
  box-shadow: 0 10px 30px rgba(0, 102, 204, 0.2);
  transition: var(--transition);
}

.structure-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 102, 204, 0.3);
}

.structure-number {
  font-size: 56px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 16px;
  color: var(--white);
}

.structure-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--white);
}

.structure-description {
  font-size: 15px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.95);
}

.phases-content {
  background: var(--light-color);
  padding: 60px;
  border-radius: 20px;
}

.phases-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--dark-color);
  text-align: center;
  margin-bottom: 40px;
}

.phases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.phase-card {
  background: var(--white);
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: var(--transition);
}

.phase-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.phase-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  margin-bottom: 24px;
}

.phase-icon svg {
  width: 28px;
  height: 28px;
}

.phase-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 12px;
}

.phase-description {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-light);
}

.values-section {
  background: var(--light-color);
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.value-card {
  background: var(--white);
  padding: 50px 40px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: var(--transition);
  position: relative;
  overflow: hidden;
}

.value-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.value-number {
  font-size: 64px;
  font-weight: 800;
  color: rgba(0, 102, 204, 0.1);
  line-height: 1;
  margin-bottom: 20px;
  font-family: var(--font-secondary);
}

.value-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--dark-color);
  margin-bottom: 16px;
}

.value-description {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-light);
}

.team-section {
  background: var(--white);
}

.team-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 900px;
  margin: 0 auto;
}

.team-stat {
  text-align: center;
  padding: 50px 30px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  border-radius: 16px;
  color: var(--white);
  box-shadow: 0 10px 30px rgba(0, 102, 204, 0.2);
  transition: var(--transition);
}

.team-stat:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 102, 204, 0.3);
}

.team-stat-number {
  display: block;
  font-size: 48px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 12px;
}

.team-stat-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
}

.partnership-section {
  background: var(--white);
}

.partnership-content {
  max-width: 900px;
  margin: 0 auto;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  padding: 60px;
  border-radius: 20px;
  color: var(--white);
  box-shadow: 0 20px 60px rgba(0, 102, 204, 0.2);
}

.partnership-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--white);
  margin-bottom: 24px;
  line-height: 1.3;
}

.partnership-text {
  font-size: 16px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 20px;
}

.partnership-text:last-child {
  margin-bottom: 0;
}

.join-section {
  background: var(--light-color);
}

.join-card {
  background: linear-gradient(135deg, var(--dark-color) 0%, #2D2D2D 100%);
  padding: 80px 60px;
  border-radius: 20px;
  text-align: center;
  color: var(--white);
  position: relative;
  overflow: hidden;
}

.join-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 163, 224, 0.15) 0%, transparent 70%);
}

.join-title {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 24px;
  color: var(--white);
  position: relative;
  z-index: 2;
}

.join-description {
  font-size: 18px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  max-width: 700px;
  margin: 0 auto 40px;
  position: relative;
  z-index: 2;
}

.join-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  position: relative;
  z-index: 2;
}

@media (max-width: 968px) {
  .page-title {
    font-size: 38px;
  }

  .content-grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .content-image {
    order: -1;
  }

  .structure-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .phases-content {
    padding: 40px 30px;
  }

  .phases-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .values-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .team-stats {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .partnership-content {
    padding: 40px 30px;
  }

  .partnership-title {
    font-size: 26px;
  }

  .join-actions {
    flex-direction: column;
  }

  .join-actions .btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .page-hero {
    padding: 120px 0 60px;
  }

  .page-title {
    font-size: 32px;
  }

  .structure-card {
    padding: 30px 24px;
  }

  .structure-number {
    font-size: 42px;
  }

  .phases-content {
    padding: 30px 24px;
  }

  .phases-title {
    font-size: 24px;
  }

  .phase-card {
    padding: 30px 24px;
  }

  .value-card {
    padding: 40px 30px;
  }

  .value-number {
    font-size: 48px;
  }

  .partnership-content {
    padding: 30px 24px;
  }

  .partnership-title {
    font-size: 22px;
  }

  .join-card {
    padding: 50px 30px;
  }

  .join-title {
    font-size: 32px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,yFAAyF;EACzF,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yFAAyF;EACzF,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yFAAyF;EACzF,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yFAAyF;EACzF,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uEAAuE;EACvE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".page-hero {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  padding: 160px 0 96px;\n  color: var(--white);\n  margin-bottom: 0;\n}\n\n.page-hero-content {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.page-subtitle {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  color: rgba(255, 255, 255, 0.95);\n  margin-bottom: 24px;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 24px;\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.page-title {\n  font-size: 56px;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 28px;\n  color: var(--white);\n  letter-spacing: -0.5px;\n}\n\n.page-description {\n  font-size: 18px;\n  line-height: 1.8;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.about-content {\n  background: var(--white);\n}\n\n.content-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 80px;\n  align-items: center;\n}\n\n.content-title {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 32px;\n}\n\n.content-paragraph {\n  font-size: 16px;\n  line-height: 1.9;\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n.content-image {\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n.content-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n  aspect-ratio: 4/5;\n}\n\n.mission-structure {\n  background: var(--white);\n}\n\n.structure-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n  margin-bottom: 60px;\n}\n\n.structure-card {\n  text-align: center;\n  padding: 40px 30px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  border-radius: 16px;\n  color: var(--white);\n  box-shadow: 0 10px 30px rgba(0, 102, 204, 0.2);\n  transition: var(--transition);\n}\n\n.structure-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(0, 102, 204, 0.3);\n}\n\n.structure-number {\n  font-size: 56px;\n  font-weight: 800;\n  line-height: 1;\n  margin-bottom: 16px;\n  color: var(--white);\n}\n\n.structure-title {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: var(--white);\n}\n\n.structure-description {\n  font-size: 15px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.phases-content {\n  background: var(--light-color);\n  padding: 60px;\n  border-radius: 20px;\n}\n\n.phases-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--dark-color);\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.phases-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n}\n\n.phase-card {\n  background: var(--white);\n  padding: 40px 30px;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: var(--transition);\n}\n\n.phase-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.phase-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  margin-bottom: 24px;\n}\n\n.phase-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.phase-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 12px;\n}\n\n.phase-description {\n  font-size: 14px;\n  line-height: 1.8;\n  color: var(--text-light);\n}\n\n.values-section {\n  background: var(--light-color);\n}\n\n.values-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 30px;\n}\n\n.value-card {\n  background: var(--white);\n  padding: 50px 40px;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: var(--transition);\n  position: relative;\n  overflow: hidden;\n}\n\n.value-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.value-number {\n  font-size: 64px;\n  font-weight: 800;\n  color: rgba(0, 102, 204, 0.1);\n  line-height: 1;\n  margin-bottom: 20px;\n  font-family: var(--font-secondary);\n}\n\n.value-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--dark-color);\n  margin-bottom: 16px;\n}\n\n.value-description {\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--text-light);\n}\n\n.team-section {\n  background: var(--white);\n}\n\n.team-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.team-stat {\n  text-align: center;\n  padding: 50px 30px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  border-radius: 16px;\n  color: var(--white);\n  box-shadow: 0 10px 30px rgba(0, 102, 204, 0.2);\n  transition: var(--transition);\n}\n\n.team-stat:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(0, 102, 204, 0.3);\n}\n\n.team-stat-number {\n  display: block;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1;\n  margin-bottom: 12px;\n}\n\n.team-stat-label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.partnership-section {\n  background: var(--white);\n}\n\n.partnership-content {\n  max-width: 900px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  padding: 60px;\n  border-radius: 20px;\n  color: var(--white);\n  box-shadow: 0 20px 60px rgba(0, 102, 204, 0.2);\n}\n\n.partnership-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--white);\n  margin-bottom: 24px;\n  line-height: 1.3;\n}\n\n.partnership-text {\n  font-size: 16px;\n  line-height: 1.9;\n  color: rgba(255, 255, 255, 0.95);\n  margin-bottom: 20px;\n}\n\n.partnership-text:last-child {\n  margin-bottom: 0;\n}\n\n.join-section {\n  background: var(--light-color);\n}\n\n.join-card {\n  background: linear-gradient(135deg, var(--dark-color) 0%, #2D2D2D 100%);\n  padding: 80px 60px;\n  border-radius: 20px;\n  text-align: center;\n  color: var(--white);\n  position: relative;\n  overflow: hidden;\n}\n\n.join-card::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 500px;\n  height: 500px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(0, 163, 224, 0.15) 0%, transparent 70%);\n}\n\n.join-title {\n  font-size: 42px;\n  font-weight: 700;\n  margin-bottom: 24px;\n  color: var(--white);\n  position: relative;\n  z-index: 2;\n}\n\n.join-description {\n  font-size: 18px;\n  line-height: 1.8;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 700px;\n  margin: 0 auto 40px;\n  position: relative;\n  z-index: 2;\n}\n\n.join-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n}\n\n@media (max-width: 968px) {\n  .page-title {\n    font-size: 38px;\n  }\n\n  .content-grid {\n    grid-template-columns: 1fr;\n    gap: 50px;\n  }\n\n  .content-image {\n    order: -1;\n  }\n\n  .structure-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .phases-content {\n    padding: 40px 30px;\n  }\n\n  .phases-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .values-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .team-stats {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .partnership-content {\n    padding: 40px 30px;\n  }\n\n  .partnership-title {\n    font-size: 26px;\n  }\n\n  .join-actions {\n    flex-direction: column;\n  }\n\n  .join-actions .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 640px) {\n  .page-hero {\n    padding: 120px 0 60px;\n  }\n\n  .page-title {\n    font-size: 32px;\n  }\n\n  .structure-card {\n    padding: 30px 24px;\n  }\n\n  .structure-number {\n    font-size: 42px;\n  }\n\n  .phases-content {\n    padding: 30px 24px;\n  }\n\n  .phases-title {\n    font-size: 24px;\n  }\n\n  .phase-card {\n    padding: 30px 24px;\n  }\n\n  .value-card {\n    padding: 40px 30px;\n  }\n\n  .value-number {\n    font-size: 48px;\n  }\n\n  .partnership-content {\n    padding: 30px 24px;\n  }\n\n  .partnership-title {\n    font-size: 22px;\n  }\n\n  .join-card {\n    padding: 50px 30px;\n  }\n\n  .join-title {\n    font-size: 32px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
